'use strict';

var angular = require('angular');
var modules = ['AVRO.Common.Configuration'];
module.exports = angular.module('AVRO.PricingAnalysis.PricingDepartureDatesLegendFilter', modules).factory('PricingDepartureDatesLegendFilterService', require('./services/PricingDepartureDatesLegendFilterService'));